import { gql } from "@apollo/client";

export const GET_EXPERT_STATE_FOR_LIFESTYLE = gql`
  query getExpertStateForLifestyle($id: Int!) {
    getExpert(id: $id) {
      state
    }
  }
`;
